export default {
  // 學生註冊
  nameZh: '中文名',
  nameEN: '英文名',
  lastName: '姓(拼音形式)',
  firstName: '名(拼音形式)',
  gender: '性別',
  female: '女',
  male: '男',
  title: '稱謂',
  birthday: '出生日期',
  phoneNumber: '學生聯系電話',
  phoneRegion: '區號',
  account: '帳號',
  email: '電子郵件',
  emailTips:'【重要:請確保郵箱準確，可以正常接收郵件，否則會影響申請的進度】',
  emailPassword: '電子郵件密碼',
  country: '國家/地區',
  state: '省',
  city: '市',
  region: '區',
  postcode: '郵政編碼',
  address: '聯系地址',
  alternativeAddr: '備選聯系地址',
  fillApply: '保存並填寫入學申請',
  returnStuList: '返回列表',
  fkAreaRegion: '區域',
  saveTemporal: "信息待完善，暫存",
  moreEmailTips:' (多個郵箱請用（；+空格）隔開)',
  viewStudentsAddApplications:'查看學生並進行加申操作',
  duplicateStudentTips:'偵測到，重複學生有{num}個！',
  viewStudentsEditThem:'查看學生並進行編輯操作',
  shareLink:'共享連結',
  notStudentEmail:'(非學生電郵)',

  // 學生資料管理
  isLivedSinceBirth: '是否自出生便在這個國家/地區居住？',
  fkStudentAppCountryIdLive: '目前所在國家/地區',
  migrationTime: '移居時間',
  stayingRightTime: '取居留權時間',
  isHavePassport: '是否有護照',
  fkStudentAppCountryIdPassport: '簽發國家/地區',
  passportIssueDate: '簽發日期',
  passportIssueExpried: '有效期至',
  passportNumber: '護照號碼',
  followUpPhoneCode: '區號',
  followUpPhoneNumber1: "跟進聯繫人電話號碼1",
  followUpPhoneCode1: '區號1',
  followUpEmail1: '跟進人電郵1',
  followUpPhoneNumber2: "跟進聯繫人電話號碼2",
  followUpPhoneCode2: '區號2',
  followUpEmail2: '跟進人電郵2',
  followUpPhoneNumber3: "跟進聯繫人電話號碼3",
  followUpPhoneCode3: '區號3',
  followUpEmail3: '跟進人電郵3',
  passportInfo: '護照信息',
  contactPerson: '聯系負責人',
  contactNotice: '(建議提供顧問老師手機號碼，以便收取系統推送學生個案進展)',
  atLeastOne: '(至少填寫一個)',
  fkStudentAppCountryId: '學生國籍/地區',
  fkStudentAppAncestryId: '學生種族',
  fkStudentAppMotherLanguageId: '學生母語',
  fkStudentAppCountryIdBirth: '出生國家/地區',
  cityBirth: '出生城市',
  idCardNumber: '身份證號碼',
  idCardNumberTips: '【說明：如學生來自中國內地，需要申請香港大學時，請務必錄入身份證號碼】',
  whetherPayment:'是否代付',

  regStartTime: '入檔開始時間',
  regEndTime: '入檔結束時間',
  openTimeStart: '开學開始日期',
  openTimeEnd: '开學結束日期',
  openTime: '开学日期',
  export: '導出',
  applicationStatus: '申請處理狀態',
  failureReason: '失敗原因',
  regGmtCreate: '入檔時間',
  edit: '編輯申請',
  addApplyCourse: '加申課程',
  personInfo: '個人信息',
  applyFollow: '申請跟進情況',
  allDataRegiest: '完整資料註冊',
  baseDataRegiest: '註冊基本資料',
  intelligentIdentificationStudentInfo: '智能識別學生資料',
  intelligentIdentificationTips: '智能識別通過AI技術圖像識別資料',
  intelligentIdentificationTips2_1: '2.如何',
  intelligentIdentificationTips2_2: '上傳識別',
  intelligentIdentificationTips2_3: '？點擊上方區域上傳護照（文件格式為圖片或PDF）',
  intelligentTitle: '1.請選擇護照國家/地區',
  uploadPassportNational: '上傳其他地區護照圖片',
  uploadPassport: '上傳中國大陸護照圖片',
  uploadBackground: '上傳背景資料',
  continuetofill: '手動填寫',
  continueInput: '繼續填寫',
  stuName: '姓名（中文）',
  stuNameEn: '姓名（英文）',
  stuGender: '性別',
  stuNation: '民族',
  stuBirth: '出生日期',
  stuIdcard: '身份證',
  stuBirthPlace: '出生地',
  stuPassport: '護照號碼',
  stuEduExp: '教育經歷',
  stuWorkExp: '工作經歷',
  notUpload: '未上傳',
  aiCode1:'證件邊框不完整,請重新上傳',
  aiCode2:'請上傳原件',
  aiCode3:'無法辨識文件，請重新上傳',
  aiCode4:'證件不能修改,請重新上傳',
  aiCode5:'證件有反光,請重新上傳',
  aiCode6:'證件模糊,請重新上傳',
  aiCode7:'告警能力未開通',
  // 文件下載
  studentInformation: '學生資料',

  courseApplyStatus: '申請狀態',
  courseApplyStatus0: '新建',
  courseApplyStatus1: '已提交',
  courseApplyStatus2: '補件',
  courseApplyStatus3: '加申',
  courseApplyStatus4: '顧問已提交',
  // 學生資料管理
  student: '學生',
  fkAreaCountryName: '國家/地區',
  schoolName: '學校名稱',
  courseName: '課程名稱',
  lastBmsApplyFollowStatusName: '課程申請最新狀態',
  submitInfoStatus: '資料提交狀態',
  editApplyStatus: '修改申請狀態',
  completed: '已完成',
  unCompleted: '未完成',
  current: '當前',
  notStart: '未啟動',

  // 學生申請匯總
  studentName: '學生姓名',
  studentNameZh: '學生姓名(中)',
  studentNameEn: '學生姓名(英)',
  applySchoolName: '申請學校',
  applyCourseName: '申請課程',
  courseType: '課程類型',
  bmsApplyFollowStatusName: '申請步驟狀態',
  applyTotalCount: '申請資料遞交總數',
  openingTime: '入學時間（月）',
  notISSUEStudent: '非ISSUE創建學生',
  checkIssueStudentInfo: '查看issue學生信息',

  bindOnlineForm: '綁定在線表單',
  bindSuccess: '綁定成功',
  bindErr: '綁定失敗請檢查數據',
  inputOnlineForm: '請輸入在線表單編號',
  inputOnlineFormErr: '請檢查輸入格式',
  noSelectTips: '選擇不到可進行手寫輸入',
  batchTransferStudentManagementAccounts:'批量轉學生管理帳號',
  createAccount:'建立帳號',
  currentManagementAccount:'目前管理帳號',
  transferManagementAccount:'轉移管理帳號',
  transferTips:'學生轉移後，目前帳號將看不到轉移的學生。 除非目前帳號是轉帳帳號的父級帳號。',
  noTransferData:'暫無下屬帳號可選擇',

  applyDialogTips1: '您有學生申請待提交 ！',
  applyDialogTips2: '您目前仍有未完成或尚未提交至 GEA 的申請；請查看並完成提交，以便我們繼續協助處理。',
  applyDialogTips3: '共',
  applyDialogTips4: '條申請需處理',
  applyDialogTipsButton: '前往處理',
}
